import { Provider } from 'react-redux'
import { useEffect, useState } from 'react'
import initializeStore from 'apps/studio/store'
import { StudioLayout } from 'apps/studio/components'
import {
  Loading,
  CustomLoading,
} from 'apps/builder/components/shared/animations'

// TODO: We should probably move these to FCK or another shared location
import {
  fetchForm,
  fetchStudioPdf,
  fetchEntryTypes,
  fetchOperationTypes,
  fetchReferenceData,
  fetchReferenceImages,
} from 'apps/studio/lib/builderRequests'
import { fetchLiveDataSources } from 'lib/clientUtils'
// TODO: Likely would want to have it's own set of transform/extract functions
import { unpackType, unpackOperationType } from 'apps/builder/lib/transforms'
import {
  extractForm,
  extractFlatOperations,
  extractPdf,
  extractColors,
  unpackReferenceImageType,
} from 'apps/studio/lib/transforms'
import {
  initialState as initialStudioSettingsState,
  INTRO_MODE,
  PDF_MODE,
} from 'apps/studio/store/reducers/settings/studioSettings'
import { loadAllFonts } from 'apps/studio/lib/utils/fonts'

const safelyGetInitialState = async () => {
  const { initialOnboardingState } = window
  const {
    appId,
    defaultAppName,
    featureFlags,
    supportedFonts,
    white_labeled,
    ai_settings,
    current_department_id,
    live_data_enabled,
    plgDemo,
  } = initialOnboardingState

  const [
    { data: formData },
    { data: pdfData },
    { data: entryTypeData },
    { data: operationTypeData },
    { data: referenceData },
    { data: referenceImages },
    { data: liveDataSources },
  ] = await Promise.all([
    appId ? fetchForm(appId) : Promise.resolve({ data: {} }),
    appId ? fetchStudioPdf(appId) : Promise.resolve({ data: {} }),
    fetchEntryTypes(),
    fetchOperationTypes(),
    fetchReferenceData(),
    plgDemo ? Promise.resolve({ data: [] }) : fetchReferenceImages(),
    live_data_enabled
      ? fetchLiveDataSources(current_department_id)
      : Promise.resolve({ data: [] }),
  ])

  const formEntities = extractForm(formData)

  if (!appId) {
    // New form; apply default app values
    formEntities.app = {
      name: defaultAppName,
      defaultAppName: defaultAppName,
      version: 1,
      status: 'new',
      placeholder: 'Type Form Name',
    }
  }

  const extractedPdfData = extractPdf(pdfData)

  const state = {
    entities: {
      ...formEntities,
      operations: extractFlatOperations(formEntities.operations),
      ...extractedPdfData,
    },
    types: {
      entryTypes: entryTypeData.map(unpackType(white_labeled)),
      operationTypes: operationTypeData.map(unpackOperationType),
      fontTypes: supportedFonts,
    },
    featureFlags: featureFlags || {},
    referenceData: referenceData,
    referenceImages: [],
    referenceImages: referenceImages.map(unpackReferenceImageType),
    liveDataSources,
    dataSourceContexts: formData.data_source_contexts || [],
    studioSettings: {
      ...initialStudioSettingsState,
      activeMode: appId ? PDF_MODE : INTRO_MODE,
      aiSettings: ai_settings,
      colors: extractColors(extractedPdfData),
      plgDemo: plgDemo || false,
    },
  }

  window._initial_state = state
  return state
}

export const Builder = () => {
  const [store, loadStore] = useState(false)
  const customLogo = window.whiteLabelConfig?.primaryLogo

  useEffect(() => {
    const loadInitialState = async () => {
      const initialData = await safelyGetInitialState()
      const initializedStore = initializeStore(initialData)
      loadStore(initializedStore)
      loadAllFonts(initialData)
    }
    loadInitialState()
  }, [])

  return store ? (
    <Provider store={store}>
      <StudioLayout />
    </Provider>
  ) : (
    <>{customLogo ? <CustomLoading logoUrl={customLogo} /> : <Loading />}</>
  )
}
